import { render, staticRenderFns } from "./BorderBox2.vue?vue&type=template&id=b41aac6e"
import script from "./BorderBox2.vue?vue&type=script&lang=js"
export * from "./BorderBox2.vue?vue&type=script&lang=js"
import style0 from "./BorderBox2.vue?vue&type=style&index=0&id=b41aac6e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports